// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__27amX","block":"styles_block__2iNZx"};